module.exports = "<a ng-if=\"marketplaceAdminRegCtrl.isAdminOrTeamLeader\" ng-click=\"marketplaceAdminRegCtrl.register()\">{{marketplaceAdminRegCtrl.text || 'Register Users'}}</a>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/marketplaceAdminReg/template.html
// module id = 1296
// module chunks = 0